import cookie from 'js/lib/cookie';

const ADMIN_V2_COOKIE_NAME = 'admin_show_v2';
export const setAdminV2Cookie = (): string => cookie.set(ADMIN_V2_COOKIE_NAME, true);
export const removeAdminV2Cookie = (): void => cookie.remove(ADMIN_V2_COOKIE_NAME);

export const isAdminV2Enabled = (): boolean => true;
